import { Switch, withStyles } from "@material-ui/core";

export const IzySwitch = withStyles((theme) => ({
    root: {
        width: 38,
        height: 22,
        padding: 0,
        margin: theme.spacing(1),
      },
      switchBase: {
        padding: 1,
        color: '#757575',
        '&$checked': {
          transform: 'translateX(12.2px)',
          color: theme.palette.common.white,
          '& + $track': {
            backgroundColor: '#52d869',
            opacity: 1,
            border: 'none',
          },
        },
        '&$focusVisible $thumb': {
          color: '#52d869',
          border: '6px solid #fff',
        },
      },
      thumb: {
        width: "14px !important",
        height: "14px !important",
      },
      track: {
        borderRadius: 22 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
      },
      checked: {},
  }))(Switch);